/**
 * XHR-based API utility to bypass platform fetch interceptor
 * that consumes response bodies.
 */

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const getToken = () => localStorage.getItem('session_token');

const request = (method, path, body = null) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const url = path.startsWith('http') ? path : `${API_URL}${path}`;
    xhr.open(method, url);
    xhr.withCredentials = true;

    const token = getToken();
    if (token) xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    if (body !== null) xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onload = () => {
      let data;
      try { data = JSON.parse(xhr.responseText); }
      catch { data = xhr.responseText; }
      const ok = xhr.status >= 200 && xhr.status < 300;
      resolve({ ok, status: xhr.status, data });
    };

    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send(body !== null ? JSON.stringify(body) : null);
  });
};

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  put: (path, body) => request('PUT', path, body),
  patch: (path, body) => request('PATCH', path, body),
  delete: (path) => request('DELETE', path),
};
